import * as tslib_1 from "tslib";
import Vue from "vue";
import { Getter } from "vuex-class";
import { Component } from "vue-property-decorator";
import data from "@/services/data";
import { momentTZ } from "@/helpers/moment";
let DownloadButton = class DownloadButton extends Vue {
    async download() {
        let profiles = {};
        for (let profileID of this.selectedProfiles) {
            console.log("profile:", profileID);
            profiles[profileID] = this.allProfilesByID[profileID].name;
        }
        await data.downloadData({
            from_millis: 1522579500000,
            to_millis: momentTZ().unix() * 1000,
            tz: this.tzName,
            profile_ids: profiles
        });
        console.log("download done!");
    }
};
tslib_1.__decorate([
    Getter("auth/profileByID")
], DownloadButton.prototype, "allProfilesByID", void 0);
tslib_1.__decorate([
    Getter("config/profileIds")
], DownloadButton.prototype, "selectedProfiles", void 0);
tslib_1.__decorate([
    Getter("tzName")
], DownloadButton.prototype, "tzName", void 0);
DownloadButton = tslib_1.__decorate([
    Component
], DownloadButton);
export default DownloadButton;
